<div id="main-container" class="col-md-4 bannerBg">
  <h1 class="adovacyTitle">{{ mainTitle }}</h1>
</div>

@for (text of texts; track text) {
  <div id="questionLists" class="col-md-10 mt-5">
    <p>
      {{ text.text }}
    </p>
    <p>
      {{ text.text2 }}
    </p>
    <p>
      {{ text.text3 }}
    </p>
  </div>
}
